import React, { useState } from "react";
import { MainContainer, MainRow, MainCol } from "components/common";
import { MainHeroSection } from "./styles";
import MainNavbar from "components/navbar/mainNavbar";
import { BsCurrencyDollar } from "react-icons/bs";
// import discord from "assets/discord.png";
// import twitter from "assets/twitter.png";
// import world from "assets/world.png";
// import share from "assets/share.png";
import check from "assets/check.png";
import Dropdown from "react-bootstrap/Dropdown";

import {
  BsTwitter,
  FaDiscord,
  BsFillShareFill,
  BiWorld,
  BsFacebook,
  BsTelegram,
  AiFillCopy,
} from "react-icons/all";
import SecondaryNavbar from "components/navbar/secondaryNavbar";
import { CommonUtility } from "utility";
import { ToastMessage } from "components/common";

const HeroSection = ({ data }) => {
  const [secondaryNavbar, setCecondaryNavbar] = useState(true);

  const clipToCopy = () => {
    ToastMessage("Link Copied Successfully", "", "success");
    navigator.clipboard.writeText(window?.location?.href);
  };

  return (
    <MainHeroSection>
      <SecondaryNavbar />
      <MainContainer>
        <div className="heroDetailsInfo ms-lg-3">
          <div className="mainTitle">
            <h1>{data?.name}</h1>
            <div className="byTitle">
              <p>
                {" "}
                <span> By</span>{" "}
                {data.username
                  ? data.username
                  : CommonUtility.addressConvertor(data.owner_address)}
                <img className="ms-3" src={check} />
              </p>
            </div>
          </div>

          <div className="socialICons">
            <div className="socialMain">
              <div className="socialIcon">
                <a href="https://twitter.com/NethtyNFT" target="_blank">
                  <BsTwitter />
                </a>
              </div>
              <div className="socialIcon">
                <a href="https://discord.com" target="_blank">
                  <FaDiscord />
                </a>
              </div>

              <div className="socialIcon">
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic">
                    <BsFillShareFill />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      href="https://www.facebook.com/"
                      target="_blank"
                    >
                      <BsFacebook
                        style={{
                          color: "#575757",
                          fontSize: "20px",
                          marginBottom: "5px",
                          marginRight: "10px",
                        }}
                      />
                      Share On Facebook
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="https://web.telegram.org/"
                      target="_blank"
                    >
                      <BsTelegram
                        style={{
                          color: "#575757",
                          fontSize: "20px",
                          marginBottom: "5px",
                          marginRight: "10px",
                        }}
                      />
                      Share On Telegram
                    </Dropdown.Item>
                    <Dropdown.Item href="" onClick={clipToCopy}>
                      <AiFillCopy
                        style={{
                          color: "#575757",
                          fontSize: "20px",
                          marginBottom: "5px",
                          marginRight: "10px",
                        }}
                      />{" "}
                      Copy Link
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
        <div className="infoSection">
          <div className="infoSectionItm">
            <p>{data.items?.length}</p>
            <p className="mt-1">Items</p>
          </div>
          <div className="infoSectionItm">
            <p>{data.owners}</p>
            <p className="mt-1">Owners</p>
          </div>
          {/* <div className="infoSectionItm">
            <p>1.15K</p>
            <p className="mt-1">floor Price</p>
          </div> */}
          <div className="infoSectionItm">
            <p>
              {" "}
              <BsCurrencyDollar style={{ marginBottom: "3px" }} />
              {data.totalVolume}
            </p>
            <p className="mt-1">Total Volumes</p>
          </div>
        </div>
        {/* <div className="buttonSection">
          <button className="offerBtn">Make a Collection Offer</button>
        </div> */}
      </MainContainer>
    </MainHeroSection>
  );
};

export default HeroSection;
